module.exports = __webpack_public_path__ + "static/img/list.76dedeca.svg";